// extracted by mini-css-extract-plugin
export default {"sliderEmptyState":"XX1XcE"};